import React, { useState, useRef } from "react";
import {
  Container,
  DateSpace,
  Icon,
  StatusSpace,
  TaskAtach,
  TaskChat,
  TaskDate,
  TaskName,
  TaskStatus,
} from "./styles";
import Flag from "../../../assets/icons/Flag";

import Check from "../../../assets/icons/Check";
import Clip from "../../../assets/icons/clip";
import Chat from "../../../assets/icons/Chat";
import { DateTime } from "luxon";

const verifyCurrentStatus = (task) => {
  if (task.status === "doing" || task.status === "done") {
    return task.moment.currentStatus;
  }

  return task.status;
};

const verifyMoment = (task) => {
  const status = task.status;
  let moment = "idle";
  let currentStatus = "idle";

  switch (status) {
    case "done":
      currentStatus = task.moment.currentStatus;

      if (currentStatus === "done") {
        moment = "Concluído";
      } else {
        moment = "Concluído com Atraso";
      }
      break;
    case "doing":
      currentStatus = task.moment.currentStatus;

      if (currentStatus === "doing") {
        moment = "Em execução";
      } else {
        let time =
          task.moment.diffDays <= -1
            ? -task.moment.diffDays.toFixed(1) + " dias"
            : -task.moment.diffHours.toFixed(0) + " hora(s)";
        moment = "Atrasada em ~" + time;
      }
      break;
    case "pending":
      moment = "Pendente";
      break;
    default:
      break;
  }

  return moment;
};

const verifyPrevision = (task) => {
  if (task.status === "doing") {
    return DateTime.fromMillis(task.moment.deadline).toLocaleString(
      DateTime.DATE_MED,
    );
  } else if (task.status === "done") {
    return DateTime.fromMillis(task.moment.finishedAt).toLocaleString(
      DateTime.DATE_MED,
    );
  } else {
    return "Previsão indisponível";
  }
};

const Iterable = ({ setTask, project, tasks }) => {
  const anchorRef = useRef(null);

  return tasks.map((item, index) => (
    <Container
      onClick={() => setTask({ current: item, isOpen: true })}
      key={"task" + index}
    >
      <Icon ref={anchorRef}>
        {item.accountable ? (
          <img
            alt=""
            title={item.accountable.username}
            src={item.accountable.avatarURL}
          />
        ) : null}
      </Icon>
      <TaskName>{item.label}</TaskName>
      <StatusSpace>
        <TaskStatus status={verifyCurrentStatus(item)}>
          {verifyMoment(item)}
        </TaskStatus>
      </StatusSpace>
      <DateSpace>
        <TaskDate status={verifyCurrentStatus(item)}>
          <Flag />
          {verifyPrevision(item)}
        </TaskDate>
      </DateSpace>
      <TaskAtach>
        <Clip height="1rem" />
        {item.files}
      </TaskAtach>
      <TaskChat>
        <Chat height="1rem" />
        {item.chatMessages}
      </TaskChat>
    </Container>
  ));
};

export default Iterable;
